export const images = {
  // logo_blue: require("../../../assets/images/logo_jala.png"),
  // logo_white: require("../../../assets/images/logo-white.png"),
  // googleLogo: require("../../../assets/images/google_logo.png"),
  // facebookLogo: require("../../../assets/images/facebook_logo.png"),
  // appleLogo: require("../../../assets/images/apple_logo.png"),
  // home: require("../../../assets/images/home.png"),
  // profile: require("../../../assets/images/profile.png"),
  // graph: require("../../../assets/images/graph.png"),
  // help: require("../../../assets/images/help.png"),
  // quick: require("../../../assets/images/quick_input.png"),
  // consult: require("../../../assets/images/consult.png"),
  // banner1: require("../../../assets/images/banner1.png"),
  // banner2: require("../../../assets/images/banner2.png"),
  // banner3: require("../../../assets/images/banner3.png"),
  // banner4: require("../../../assets/images/banner4.png"),
  // banner5: require("../../../assets/images/banner5.png"),
  // banner6: require("../../../assets/images/banner6.png"),
  // banner7: require("../../../assets/images/banner7.png"),
  // banner8: require("../../../assets/images/banner8.png"),
  // logout: require("../../../assets/images/logout.png"),
  // offline: require("../../../assets/images/offline.png"),
  // empty_simulation: require("../../../assets/images/empty-simulation.png"),
  // occupation: require("../../../assets/images/occupation.png"),
  // empty_notes: require("../../../assets/images/empty_notes.png"),
}
